import {Platform} from 'react-native';

if (__DEV__) {
  console.log('***** App running in Development mode. *****');
} else {
  console.log('***** App running in Production mode. *****');
}

const appName = 'Secretaire';


let apiBaseUrl = 'https://api.secretaire.ai';
let assetsBaseUrl = 'https://api.secretaire.ai';
let webBaseUrl = 'https://www.secretaire.ai';
let webSocketBaseUrl = 'wss://api.secretaire.ai/cable';

// let apiBaseUrl = 'http://192.168.1.183:3000';
// let apiBaseUrl = 'https://staging.secretaire.ai';

let roomSlug = null;


if (Platform.OS === 'web') {



  // Check whether API endpoints are set by the backend
  try {
    console.log('API_BASE_URL is set from server-side authentication', API_BASE_URL);
    apiBaseUrl = API_BASE_URL;
  } catch (error) {
    console.log('API_BASE_URL do not exist in server-side authentication');
    console.log('apiBaseUrl', apiBaseUrl);
  }


  // Check whether user is already authenticated server-side
  try {
    console.log('ROOM_SLUG', ROOM_SLUG);
    roomSlug = ROOM_SLUG;
    console.log('ROOM_SLUG set from server-side authentication');
  } catch (error) {
    console.log('ROOM_SLUG do not exist in server-side authentication');
    const splitHostName = window.location.hostname.split('.');
    let exceptionSubdomains = ["api", "app", "chat", "dev", "local", "heroku", "staging", "app-dev", "app-local", "app-staging", "www"];
    roomSlug = splitHostName.length > 1
      ? exceptionSubdomains.includes(splitHostName[0]) ? null : splitHostName[0]
      : null;
    console.log('roomSlug', roomSlug);
  }


}


console.log('apiBaseUrl', apiBaseUrl);
console.log('assetsBaseUrl', assetsBaseUrl);
console.log('webBaseUrl', webBaseUrl);
console.log('webSocketBaseUrl', webSocketBaseUrl);

export default {
  roomSlug,
  appName,
  apiBaseUrl,
  assetsBaseUrl,
  webBaseUrl,
  webSocketBaseUrl,
};
